import { Guid } from "guid-typescript"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DATES = [31,28,31,30,31,30,31,31,30,31,30,31]

const KB = 1024;
const MB = KB*KB;
const GB = MB*KB;

export interface IYMD {
    year?:number
    month?:number
    date?:number
}

export default class Utils {
    static get WEEK() { return WEEK }
    
    static zero(num:number|string, digits:number=2) {
        return String(num).padStart(digits, "0")
    }
    static numDates(year:number, month:number){
        if (month==1 && ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0))) return 29
        else return DATES[month] 
    }
    static formatDate(fmt:string, date:Date|number) : string {
        const d:Date = typeof(date)=="number" ? new Date(date) : date;
        if (!d.getTime()) return "-"
        
        const month = d.getUTCMonth(), day = d.getUTCDay(), hour = d.getUTCHours();
        let h12 = hour;
        if (h12>12) h12 -= 12;
        else if (h12==0) h12 = 12;

        fmt = fmt.replace("yyyy", String(d.getUTCFullYear()));
        fmt = fmt.replace("mmm", MONTHS[month]);
        fmt = fmt.replace("MM", Utils.zero(month+1));
        fmt = fmt.replace("dd", Utils.zero(d.getDate()));
        fmt = fmt.replace("d1", d.getUTCDate().toString());
        fmt = fmt.replace("HH", Utils.zero(hour));
        fmt = fmt.replace("hh", Utils.zero(h12));
        fmt = fmt.replace("mm", Utils.zero(d.getMinutes()));
        fmt = fmt.replace("ss", Utils.zero(d.getSeconds()));
        fmt = fmt.replace("www", WEEK[d.getDay()]);
        fmt = fmt.replace("ampm", hour>=12 ? "PM" : "AM")
        return(fmt);
    }
    static sleep(milli:number) {
        return new Promise(cb => setTimeout(cb,milli))
    }
    static thousands(num:number, decimal:number=3){
        return num.toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    static kbytes(num:number){
        if (num>=GB) return ~~(num/GB) + "GB"
        else if (num>=MB) return ~~(num/MB) + "MB"
        else if (num>=KB) return ~~(num/KB) + "KB"
        else return ""+num
    }
    static guid():string { return Guid.raw() }
    static errorMsg(e:any):{title:string,message:string} {
        if (!e) return {title:"Error occurred", message:"Unknown"}
        if (typeof(e)=="string") return {title:"Error occurred",message:e}
        else if (typeof(e)=="number") return {title:`Error occurred (${e})`,message:""}
        else if (e instanceof Object && e.response) {
            const {status,responseText,data} = e.response
            const title = `Error ${status||0}`
            if (data && data instanceof Object && data.msg) return {title,message:data.msg}
            else if (typeof(data)=="string") return {title,message:data}
            else return {title,message:responseText||JSON.stringify(data)}
        }
        else if (e instanceof Object && e.status) return {title:`Error occurred (${e.status})`,message:e.msg || ""}
        else return {title:"Error occurred",message:JSON.stringify(e,null,2)}
    }
    static httpStatus(e:any){
        if (!e) return 500
        else if (typeof(e)=="number") return e
        else if (e instanceof Object){
            if (typeof(e.status)=="number") return e.status
            else if (e.response && e.response instanceof Object) return e.response.status
            else return 500
        }
        else return 500
    }
    static clipboard(val:string){
        navigator.clipboard.writeText(val)
    }
    static dateAdd(date:Date, add:IYMD){
        let ret = new Date(date)
        if (add.year) ret = new Date(ret.setFullYear(ret.getFullYear()+add.year))
        if (add.month) ret = new Date(ret.setMonth(ret.getMonth()+add.month))
        if (add.date) ret = new Date(ret.setDate(ret.getDate()+add.date))
        return ret
    }
    static exportFile(blob:Blob, filename:string) {
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.setAttribute("href", url)
        link.setAttribute("download", `${filename}.json`)
        link.setAttribute("style", "visibility:hidden")
        document.body.append(link)
        link.click()
        link.remove();         
    }
}